<template>
    <div class="w-full mb-3">
        <Button label="Сбросить" @click="clear()" icon="pi pi-refresh" iconPos="right" severity="secondary" class="p-button-sm border-round-md border-0 text-xs font-medium"/>
    </div>
    <DataTable v-if='accounts' :value="accounts" responsiveLayout="scroll" v-model:filters="filters"
        @page="onPage($event)" @sort="onSort($event)" @filter="onFilter($event)" filterDisplay="menu" 
        lazy paginator :rows="lazyParams.rows" :rowsPerPageOptions="[5, 10, 20, 50, 100, 200, 300, 400, 500]" :totalRecords="total" :loading="loading" >

        <Column field="_id">
            <template #header>
                <span class="text-xs font-medium">ID</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-1 text-xs vertical-align-middle justify-content-start align-items-center">
                    <span class="flex my-auto overflow-hidden" style="max-width:5em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.id }}
                        </span>
                    </span>...
                    <Button @click="copy(data.id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                </div> 
            </template>
        </Column>

        <Column field="balance">
            <template #header>
                <span class="text-xs font-medium">Баланс</span>
            </template>
            <template #body="{ data }">
                <span v-if="data.balance" v-tooltip="{ value: data.balance }" class="white-space-nowrap">
                    {{ getFormatAmount(data.balance, data.currency) }}
                </span>
            </template>
        </Column>

        <Column field="currency">
            <template #header>
                <span class="text-xs font-medium">Валюта</span>
            </template>
            <template #body="{ data }">
                <span class="text-sm flex flex-row uppercase">
                    {{ data.currency }}
                </span>
            </template>
        </Column>

        <Column field="acc">
            <template #header>
                <span class="text-xs font-medium">Счет</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-1 vertical-align-middle justify-content-start">
                    <Button label="Счет" @click="goTo(data.id, 'account')" 
                        class="p-button-sm border-round-md border-0 text-xs font-medium" severity="info"/>
                    <Button @click="goTo(data._id, 'account', true)" 
                        class="p-button-sm border-round-md border-0 text-xs font-medium" 
                        icon="pi pi-external-link" outlined severity="info"/>  
                </div>
            </template>
        </Column>

        <Column field="created_at" dataType="date">
            <template #header>
                <span class="text-xs font-medium">Создан</span>
            </template>
            <template #body="slotProps">
                <span class="text-xs flex flex-row">
                    {{ formatDate(slotProps.data.created_at) }}
                </span>
            </template>
        </Column>

        <template #footer>
            <span class="text-sm text-600 font-medium">
                Всего {{ total }} счетов 
            </span>
        </template>

    </DataTable>

    <Dialog header="info" v-model:visible="displayDialog" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" >
        <div class="w-full mb-3">
            <span v-for="(d,k) in detail_data" class="block mb-2">
                {{ k }}: <span class="font-medium">{{ d }}</span> <br>
            </span>
        </div>
    </Dialog>
</template>


<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import { useRoute } from 'vue-router'

export default {
    props: ['accounts', 'total', 'account_id', 'loading', 'defaultParams'],
    data() {
        return {
            displayDialog: false,
            detail_data: null,
            currencies: ['usdt', 'rub'],
            statuses:   ['pending', 'success', 'failed', 'completed', 'canceled'],
            priorities: ['low', 'medium', 'high'],
            types:      ['service', 'freeze', 'liquidity', 'withdraw', 'deposit', 'virtual', 'virtual_debit'],
            ext_types:  ['fund', 'deposit', 'vcard', 'partner', 'merchant', 'comission', 'vendor', 'withdraw', 'liquidity', 'freeze', 'service'],
            lazyParams: this.defaultParams,
            filters: {
                _id:            {value: '', matchMode: 'contains'},
                currency:       {value: '', matchMode: 'contains'},
                wallet_id:      {value: '', matchMode: 'contains'},
                status:         {value: '', matchMode: 'contains'},
                type:           {value: '', matchMode: 'contains'},
                ext_type:       {value: '', matchMode: 'contains'},
                is_blockchain:  {value: null, matchMode: 'contains'},
                is_negative:    {value: null, matchMode: 'contains'},
                priority:       {value: null, matchMode: 'contains'},
                subscribed:     {value: null, matchMode: 'contains'},
                'blockchain.address':        {value: '', matchMode: 'contains'},
            },
            sort: {
                field: '_id',
                order: 1
            },
            blockTypes: [
                {label: 'Все', value: null},
                {label: 'Блокчейн', value: true},
                {label: 'Виртуальный', value: false},
            ],
            priorityTypes: [
                {label: 'Все', value: null},
                {label: 'Низкий', value: 'low'},
                {label: 'Средний', value: 'medium'},
                {label: 'Высокий', value: 'high'},
            ],
            negativeTypes: [
                {label: 'Все', value: null},
                {label: 'Да', value: true},
                {label: 'Нет', value: false},
            ],
            subscribedTypes: [
                {label: 'Все', value: null},
                {label: 'Да', value: true},
                {label: 'Нет', value: false},
            ],
        }
    },
    computed: {
        accessCodes: function () { return this.$store.getters.StateUserAccessCodes },
    },
    methods: {
        getFormatAmount(value, currency, digits=2) {
            return this.helper.format_amount(value, currency, digits)
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        goToAccount(id){
            if(!id) return
            const routeData = this.$router.resolve({ path: '/personal/account/' + id }) 
            window.open(routeData.href, '_blank');
        },
        getShortId(value){
            if(!value) return ''
            return '..'+this.helper.get_short_id(value)
        },
        getShortAddress(value){
            if(!value) return ''
            return this.helper.get_short_name(value)
        },
        goTo(id, type, new_tab = false) {
            if(!id) return
            if(!type) return
            if(new_tab){
                const routeData = this.$router.resolve({path: '/personal/'+type+'/' + id});
                window.open(routeData.href, '_blank');
            } else this.$router.push({ path: '/personal/'+type+'/' + id })
        },
        detail_info(data) {
            this.displayDialog = true
            this.detail_data = data
        },
        onPage(event) {
            this.lazyParams = event
            this.$emit('lazyParams', this.lazyParams)
        },
        onSort(event) {
            if(event.sortField && event.sortOrder){
                this.sort = {
                    field: event.sortField,
                    order: event.sortOrder
                }
            } else {
                this.sort = {
                    field: 'date_created',
                    order: -1
                }
            }
            this.lazyParams.sort = this.sort
            this.$emit('lazyParams', this.lazyParams)
        },
        onFilter() {
            this.lazyParams.filters = this.filters
            this.$emit('filter', this.filters)
        },
        clear() {
            this.filters = {
                _id: {value: '', matchMode: 'contains'},
                currency: {value: '', matchMode: 'contains'},
                type: {value: '', matchMode: 'contains'},
                is_blockchain: {value: null, matchMode: 'contains'},
            }
            this.lazyParams.filters = this.filters
            this.$emit('filter', this.filters)
        },
        getClassByLabel(label){
            return this.helper.GetClassByLabel(label)
        },
        GetWalletNameByLabel(label){
            return this.helper.GetWalletNameByLabel(label)
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
    },
}
</script>